module.exports = __webpack_public_path__ + "static/media/evangelion_screen1.7c7f3393.gif";